module.exports = __webpack_public_path__ + "static/media/slider-arrow-left.67e33134.svg";